import { render, staticRenderFns } from "./QuestionnairesDermatitis.vue?vue&type=template&id=18e07ce8&lang=pug&"
import script from "./QuestionnairesDermatitis.vue?vue&type=script&lang=js&"
export * from "./QuestionnairesDermatitis.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnairesDermatitis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports